export const environment = {
  production: false,
  enableServiceWorker: false,
  b2cConfig: {
    isAuthenticationEnabled: true,
    auth: {
      clientId: '8707e5c6-724e-4b0b-acc1-d92208e8bedb',
      authority:
        'https://B2CGPSTG.b2clogin.com/B2CGPSTG.onmicrosoft.com/B2C_1A_GP_SIGNIN_OIDC',
      redirectUri: 'https://bewelltogether.ciodev.accenture.com',
      postLogoutRedirectUri: 'https://bewelltogether.ciodev.accenture.com',
      knownAuthorities: ['B2CGPSTG.b2clogin.com'],
    },
    policies: {
      names: {
        signUpSignIn: 'B2C_1A_GP_SIGNIN_OIDC',
      },
      authorities: {
        signUpSignIn: {
          authority:
            'https://B2CGPSTG.b2clogin.com/B2CGPSTG.onmicrosoft.com/B2C_1A_GP_SIGNIN_OIDC',
        },
      },
      authorityDomain: 'B2CGPSTG.b2clogin.com',
    },
    apiScopes: {
      employeeApi: {
        endpoint:
          'https://bwtemployee.ciodev.accenture.com/api/BWTEmployeeFunctionApp/*',
        scopes: [
          'https://accounts-stg.accenture.com/api/employeeinfo-dev/bewelltogether/user.read'
        ],
      },
    },
  },
  appInsightsConfig: {
    instrumentationKey: '4cc3704c-c6df-48a5-a66b-7f5cd1d24034',
    enableAutoRouteTracking: true,
  },
  apiBaseUrl: {
    // employeeInfo: "http://bwtemployee.ciodev.accenture.com/BWTEmployeeFunctionApp"
    employeeInfo:
      'https://bwtemployee.ciodev.accenture.com/api/BWTEmployeeFunctionApp/',
  },
};
